<section class="fx-col full-width-block" [class.no-padding]="!hasPadding" [class.has-margins]="hasMargins">
  @if (get(fullWidthRow, 'full_width_block.full_width_block[0].full_width_title') !== '') {
    <h2 class="mb-3 title">
      {{ get(fullWidthRow, 'full_width_block.full_width_block[0].full_width_title') }}
    </h2>
  }
  <img class="full-width-block-img" [src]="getFullWidthBlockSrc(fullWidthRow.full_width_block)" [attr.loading]="isBrowser ? 'lazy' : null" />
  @if (get(fullWidthRow, 'full_width_block.full_width_block[0].free_form', '') !== '') {
    <div
      [innerHTML]="get(fullWidthRow, 'full_width_block.full_width_block[0].free_form', '') | safe: 'html'"
      class="full-width-block-content mt-3 px-3"
    ></div>
  }
</section>
